export default class ButtonAction extends Core.Component {
  set size(size) {
    switch (size) {
      case 'small':
      case 'medium':
      case 'large':
        this.el.classList.remove('button-action--small', 'button-action--medium', 'button-action--large');
        this.el.classList.add(`button-action--${size}`);
        break;
      default:
        break;
    }
  }

  set style(style) {
    switch (style) {
      case 'primary':
      case 'secondary':
      case 'tertiary':
        this.el.classList.remove('button-action--primary', 'button-action--secondary', 'button-action--tertiary');
        this.el.classList.add(`button-action--${style}`);
        break;
      default:
        break;
    }
  }

  get disabled() {
    return this.el.disabled;
  }

  set disabled(disabled) {
    this.el.disabled = disabled;
  }

  get text() {
    return this.el.innerText;
  }

  set text(text) {
    this.el.innerText = text;
  }

  set loading(loading) {
    if (loading) {
      this.el.setAttribute('data-loading', '');
      this.el.setAttribute('aria-busy', true);
    } else {
      this.el.removeAttribute('data-loading');
      this.el.setAttribute('aria-busy', false);
    }
  }

  get loading() {
    return this.el.hasAttribute('data-loading');
  }
}
